import { Platform } from '@angular/cdk/platform';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorService } from './services/error.service';
import { NotificationService } from '../shared/services/notification/notification.service';
import { ApolloError } from '@apollo/client/errors';
import { environment } from '@env/environment';
import { ApolloNetworkError } from './custom-errors/apollo-network-error';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  // Error handling is important and needs to be loaded first.
  // Because of this we should manually inject the services with Injector.
  private offlineMessage =  $localize`No internet connection.`;
  private serverErrorMsg = $localize`Connection to server failed.`;
  private unauthorizedErrorMsg = $localize`You are not authorized for this action.`;
  constructor(
    private injector: Injector,
  ) { }

  handleError(error: Error | HttpErrorResponse) {

    const errorService = this.injector.get(ErrorService);
    const platform = this.injector.get(Platform);
    const notifier = this.injector.get(NotificationService);

    if (platform.isBrowser && !navigator.onLine) {
      notifier.showErrorMessage(this.offlineMessage);
      return;
    }
    if (error instanceof HttpErrorResponse) {
      // Server Error
      notifier.showErrorMessage(this.serverErrorMsg);
    } else if (error instanceof ApolloNetworkError) {
      notifier.showErrorMessage(this.serverErrorMsg);
      // const response: any = error.graphQLErrors[0]?.extensions?.response;
      // if (networkError) {
      //   // Server Error
      //   notifier.showErrorMessage(this.serverErrorMsg);
      // }  else if(response && response['statusCode'] === 401) {
      //   notifier.showErrorMessage(this.unauthorizedErrorMsg);
      // }

      errorService.handleError(error);

    } else if (error instanceof ApolloError) {
      const { graphQLErrors } = error;
        for (let err of graphQLErrors) {
          errorService.handleError(err);
        }
    } else {
      // Client Error
      errorService.handleError(error);
      notifier.showErrorMessage(error.message);
    }

    if (environment.debugOn) {
      console.error(error);
    }
  }
}
